import { useEffect, useState } from "react";
import { Country } from "../../types";
import Picker, { PickerOption } from "../widgets/components/SimplePicker";
import { SingleValue } from "react-select";
import { CountryList } from "../../DS-Files";

interface CountryPickerProp{
    label?:string
    value?:string
    onSelectionChange?: (selectedOption: SingleValue<any>) => void;
  }

  const fetchCountries = async (): Promise<Country[]> => {
    // Map the static CountryList into the required format
    return CountryList.map((country) => ({
      countryId: country.isoCode,
      countryName: country.countryName,
      currId: country.currencyCode,
    }));
  };

export const CountryPicker: React.FC< CountryPickerProp> = ({label,value,onSelectionChange}) => {
    
    const [countries, setCountries] = useState<Country[]>([]);
    const fetchData = async () => {
        const result = await fetchCountries();
        setCountries(result);
      };

      useEffect(() => {
        fetchData();
      }, []);
  
      const countryOptions = countries.map(country => ({
        value: country.countryId,
        label: `${(country.countryName)}`,
      }));

      const handleSelectChange = (selectedOption: PickerOption | null) => {
        if(onSelectionChange)
        onSelectionChange(selectedOption?.value)
    };

    return (
      <Picker label={label} value={value} options={countryOptions} onSelectionChange={handleSelectChange} placeholder={'Select Country'.toTranslatedDisplay()} />
    )
  
    
  }